/**
 * Exclusión de las visitas de administración en Google Analytics.
 * Se usa el flag oficial `window['ga-disable-<ID>']` de GA4 más una comprobación
 * antes de cada evento, de modo que los visitantes normales no se ven afectados.
 */
export const GA_MEASUREMENT_ID = 'G-BWKXB46ZVC';

export const isAdminSession = () => {
  try {
    if (window.location.pathname.startsWith('/admin')) return true;
    return !!window.localStorage.getItem('admin_token');
  } catch {
    return false;
  }
};

export const applyAnalyticsOptOut = () => {
  const disabled = isAdminSession();
  window[`ga-disable-${GA_MEASUREMENT_ID}`] = disabled;
  return disabled;
};

/** Envía un evento a GA4 salvo que haya sesión de administración. */
export const trackEvent = (name, params = {}) => {
  if (applyAnalyticsOptOut()) return;
  if (typeof window.gtag === 'function') window.gtag('event', name, params);
};

/** Normaliza un slug a un identificador de recurso para GA4: "la-ciudad" -> "la_ciudad". */
export const resourceId = (value) =>
  String(value || '')
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '');

const leadsSent = new Set();

/**
 * Evento `generate_lead` de un recurso gratuito. Se envía una sola vez por
 * recurso y solo debe llamarse cuando la descarga ya se ha completado con éxito.
 */
export const trackResourceLead = (recurso) => {
  const id = resourceId(recurso);
  if (!id || leadsSent.has(id)) return;
  leadsSent.add(id);
  trackEvent('generate_lead', { recurso: id });
};

// Se aplica al cargar el bundle, antes de cualquier navegación interna.
if (typeof window !== 'undefined') applyAnalyticsOptOut();

/* ---- Embudo de reserva (sin datos personales) ---- */

/** Clic en un CTA cuyo objetivo es reservar la clase de prueba gratuita. */
export const trackTrialCtaClick = (sourceSection) =>
  trackEvent('trial_cta_click', { source_section: sourceSection });

const bookingStarts = new Set();

/** Inicio real del proceso de reserva (paso de fecha/hora). Una vez por tipo y origen. */
export const trackBookingStart = (bookingType, sourceSection) => {
  const key = `${bookingType}|${sourceSection}`;
  if (bookingStarts.has(key)) return;
  bookingStarts.add(key);
  trackEvent('booking_start', { booking_type: bookingType, source_section: sourceSection });
};

/** Conversión: solo tras confirmarse la reserva en el backend. */
export const trackBookingLead = (bookingType) =>
  trackEvent('generate_lead', { booking_type: bookingType });
